/* eslint-disable no-use-before-define */
import React, { CSSProperties } from 'react';
import { InputAdornment, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import styles from './styles';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from 'react-i18next';

interface RBIAutocompleteInterface {
  inputRef?: any;
  onChangeInput: any;
  value: string;
  label: string;
  id: string;
  width?: number | string;
  searchIcon?: boolean;
  options: any[];
  freeSolo?: boolean;
  style?: CSSProperties;
  size?: 'medium' | 'small';
  autoFocus?: boolean;
  disabled?: boolean;
  getOptionSelected?: (option: any, value: any) => boolean;
}
const RBIAutocomplete = ({
  inputRef = null,
  onChangeInput,
  value,
  label,
  id,
  options,
  width = 150,
  searchIcon = false,
  freeSolo = true,
  getOptionSelected,
  style,
  size = 'small',
  autoFocus = false,
  disabled = false,
}: RBIAutocompleteInterface) => {
  const classes = styles();
  const onChange = (event: any, value: any) => {
    onChangeInput(id, value);
  };
  const { t } = useTranslation();
  return (
    <Autocomplete
      id={id}
      value={value}
      style={{
        ...style,
        width: width,
      }}
      size={size}
      options={options}
      disabled={disabled}
      noOptionsText={t`app.common.noOptions`}
      onChange={onChange}
      data-testid={id}
      freeSolo={freeSolo}
      className={classes.autocomplete}
      getOptionLabel={option => option.name || ''}
      getOptionSelected={getOptionSelected}
      renderInput={params => (
        <TextField
          {...params}
          inputRef={inputRef}
          label={label}
          variant="outlined"
          margin="normal"
          name={id}
          size={size}
          style={{ minWidth: width }}
          autoFocus={autoFocus}
          InputProps={{
            ...params.InputProps,
            inputProps: {
              ...params.inputProps,
              role: 'textbox',
              'data-testid': `${id}-input`,
            },
            endAdornment: searchIcon && (
              <InputAdornment position="end">
                {' '}
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
      renderOption={(option, { inputValue }) => {
        const matches = match(option.name, inputValue);
        const parts = parse(option.name, matches);

        return (
          <div>
            {parts.map((part, index) => (
              <span
                key={index}
                style={{ fontWeight: part.highlight ? 700 : 400 }}
              >
                {part.text}
              </span>
            ))}
          </div>
        );
      }}
    />
  );
};
export default RBIAutocomplete;
